import "./AnalysisPage.scss";
import React, { useEffect, useState } from "react";
import ActionHeader from "../../Reuseable/actionHeader/ActionHeader";
import aumIcon from "../../assets/Icons/aumicon.svg";
import sricon from "../../assets/Icons/sricon.svg";
import infoIcon from "../../assets/Icons/infoIcon.svg";
import cashIcon from "../../assets/Icons/cashicon.svg";
import retailIcon from "../../assets/Icons/retailIcon.svg";
import smeIcon from "../../assets/Icons/smeIcon.svg";
import { ReactComponent as SrIcon } from "../../assets/Icons/sricon.svg";
import { ReactComponent as PendingIcon } from "../../assets/Icons/recentIcon.svg";
import { ReactComponent as RedeemedIcon } from "../../assets/Icons/completed.svg";
import { ReactComponent as CountIcon } from "../../assets/Icons/graphStatsIcon.svg";
import { ReactComponent as ValueIcon } from "../../assets/Icons/cashicon.svg";

import {
  Button,
  Card,
  Checkbox,
  Divider,
  Input,
  Progress,
  Select,
  Skeleton,
  Tooltip,
} from "antd";
import HalfDonutPieChart from "../../Reuseable/HalfDonutPieChart/HalfDonutPieChart";
import { formatCurrency, formatWithCommas } from "../../assets/helpers";
import { balancePOSData, finalTotal, totalStatusData } from "./data";
import AUMDonutChart from "../../Reuseable/DonutChart/NewDonutchart";
import { useDispatch, useSelector } from "react-redux";
import { fetchAnalysis } from "../../store/analysisSlice";
import toast from "react-hot-toast";

const { Option } = Select;

const AnalysisPage = () => {
  const [primaryItems, setPrimaryItems] = useState([]);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { format } = useSelector((state) => state.priceFormat);
  const { analysis_overview, overview_loading, error } = useSelector(
    (state) => state?.analysis
  );
  const { token } = useSelector((state) => state?.auth);
  const data = analysis_overview;
  const dispatch = useDispatch();
  const [selectedTrusts, setSelectedTrusts] = useState([]);

  useEffect(() => {
    setSelectedItem(secondaryItems.length > 0 ? [secondaryItems[0]] : []);
  }, [secondaryItems]);

  const balancePOSData = {
    totalValue: data?.OverviewS1?.POSAcquired || 0,
    percentage: 0,
    items: [
      {
        title: "SME",
        icon: "🏪",
        value: data?.OverviewS1?.POSAcquiredSMEValue || 0,
        valuePercentage: data?.OverviewS1?.POSAcquiredSMEValuePercentage || 0,
        count: data?.OverviewS1?.POSAcquiredSMECount || 0,
        countPercentage: data?.OverviewS1?.POSAcquiredSMECountPercentage || 0,
      },
      {
        title: "Retail",
        icon: "🛍️",
        value: data?.OverviewS1?.POSAcquiredRetailValue || 0,
        valuePercentage: 0,
        count: data?.OverviewS1?.POSAcquiredRetailCount || 0,
        countPercentage: 0,
      },
    ],
  };
  const balancePOSData2 = {
    totalValue: data?.OverviewS1?.BalancePOS || 0,
    percentage: data?.OverviewS1?.BalancePOSPercentage,
    items: [
      {
        title: "SME",
        icon: "🏪",
        value: data?.OverviewS1?.BalancePOSSMEValue || 0,
        valuePercentage: 0,
        count: data?.OverviewS1?.BalancePOSSMECount || 0,
        countPercentage: 0,
      },
      {
        title: "Retail",
        icon: "🛍️",
        value: data?.OverviewS1?.BalancePOSRetailValue || 0,
        valuePercentage: 0,
        count: data?.OverviewS1?.BalancePOSRetailCount || 0,
        countPercentage: 0,
      },
    ],
  };
  const totalStatusData = [
    {
      title: "SR Balance",
      value: data?.OverviewS2?.SRBalance || 0,
      percentage: 0,
      Icon: SrIcon,
      accent: "blue",
    },
    {
      title: "Pending",
      value: data?.OverviewS2?.Pending || 0,
      percentage: 0,
      Icon: PendingIcon,
      accent: "amber",
    },
    {
      title: "Redeemed",
      value: data?.OverviewS2?.Redeemed || 0,
      percentage: 0,
      Icon: RedeemedIcon,
      accent: "green",
    },
  ];
  const finalTotal = [
    {
      title: "Total TOS",
      value: formatWithCommas(data?.OverviewS3?.TotalTOSCount) || 0,
      Icon: CountIcon,
    },
    {
      title: "Total TOS Value",
      value: data?.OverviewS3?.TotalTOS || 0,
      Icon: ValueIcon,
    },
  ];

  useEffect(() => {
    dispatch(fetchAnalysis());
  }, [token]);

  useEffect(() => {
    if (error !== null) {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="analysisMainPage">
      <ActionHeader
        heading="Overview"
        primaryItems={primaryItems}
        secondaryItems={secondaryItems}
        setPrimaryItems={setPrimaryItems}
        showSecondaryItems={true}
        setSecondaryItems={setSecondaryItems}
        selectedTrusts={selectedTrusts}
        setSelectedTrusts={setSelectedTrusts}
        filterKyes={["state", "region", "status"]}
        fetchData={fetchAnalysis}
      />

      <div className="row-1">
        <Card className="performance-card" loading={overview_loading}>
          <Card1
            data={{
              name: "AUM",
              value: data?.OverviewS1?.AUM || 0,
              count: data?.OverviewS1?.AUMCount || 0,
              chartData: [
                {
                  name: "",
                  value: 100 - data?.OverviewS1?.AUMcountPercentage || 0,
                },
                { name: "", value: data?.OverviewS1?.AUMcountPercentage || 0 },
              ],
              percentage: data?.OverviewS1?.AUMcountPercentage || 0,
              icon: aumIcon,
            }}
            format={format}
          />
          <Card1
            data={{
              name: "SR",
              value: data?.OverviewS1?.SR || 0,
              count: data?.OverviewS1?.SRCount || 0,
              chartData: [
                {
                  name: "",
                  value: 100 - data?.OverviewS1?.SRCountPercentage || 0,
                },
                { name: "", value: data?.OverviewS1?.SRCountPercentage || 0 },
              ],
              percentage: data?.OverviewS1?.SRCountPercentage || 0,
              icon: sricon,
            }}
            format={format}
          />
          <Card1
            data={{
              name: "Cash",
              value: data?.OverviewS1?.Cash || 0,
              count: data?.OverviewS1?.CashCount || 0,
              chartData: [
                {
                  name: "",
                  value: 100 - data?.OverviewS1?.CashCountPercentage || 0,
                },
                { name: "", value: data?.OverviewS1?.CashCountPercentage || 0 },
              ],
              percentage: data?.OverviewS1?.CashCountPercentage | 0,
              icon: cashIcon,
            }}
            format={format}
          />
        </Card>
        <Card className="balance-pos-card-wrapper" loading={overview_loading}>
          <BalancePOSCard
            balancePOSData={balancePOSData}
            name="POS Acquired"
            format={format}
          />
        </Card>
        <Card className="balance-pos-card-wrapper" loading={overview_loading}>
          <BalancePOSCard
            balancePOSData={balancePOSData2}
            name="Balance POS"
            format={format}
          />
        </Card>
      </div>
      <div className="row-2">
        {totalStatusData?.map((item) => {
          return (
            <Card
              key={item?.title}
              className={`total-status-card total-status-card--${item?.accent}`}
              loading={overview_loading}
            >
              <div className="top">
                <div className="icon-wrapper">
                  <item.Icon />
                </div>
                <h2>{item?.title}</h2>
              </div>
              <div className="bottom">
                <p>{formatCurrency(item?.value, format)}</p>
                {/* the API does not send a share for these yet, so the pill
                    stays out rather than reading a flat 0% */}
                {item?.percentage ? (
                  <div className="prencetage-indicator">
                    {item?.percentage}%
                  </div>
                ) : null}
              </div>
            </Card>
          );
        })}
        <AUMDonutChart
          loading={overview_loading}
          data={{
            pending: data?.OverviewS2?.Pending || 0,
            redeemed: data?.OverviewS2?.Redeemed || 0,
            SRBalance: data?.OverviewS2?.SRBalance || 0,
          }}
        />
      </div>
      <div className="row-3">
        <div className="totals_info">
          {finalTotal?.map((item) => {
            return (
              <div className="total-final-section" key={item?.title}>
                <div className="left">
                  {overview_loading ? (
                    <Skeleton.Input size="small" />
                  ) : (
                    <div>
                      <item.Icon />
                      <span>{item?.title}</span>
                    </div>
                  )}
                </div>
                <div className="right">
                  {overview_loading ? (
                    <Skeleton.Input size="small" />
                  ) : item?.title === "Total TOS Value" ? (
                    formatCurrency(item?.value, format)
                  ) : (
                    item?.value
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="totals_with_status">
          {overview_loading ? (
            <Skeleton.Input size="large" style={{ width: "100%" }} />
          ) : (
            <div className="pos_status">
              <span className="title">Balance POS - Recovery : </span>
              <span className="value">
                {formatCurrency(
                  data?.OverviewS3?.recovery_pos_balance_pos,
                  format
                )}
              </span>
            </div>
          )}
          <div className="status-info-wrapper">
            <div className="title_info">
              <div className="title_head">
                {overview_loading ? (
                  <Skeleton.Input size="small" />
                ) : (
                  <span>SME</span>
                )}
                <img src={infoIcon} alt="icon" />
              </div>
              {overview_loading ? (
                <Skeleton.Input size="small" />
              ) : (
                <div className="value_count">
                  <div className="value">
                    <p>Value</p>
                    <span>
                      {formatCurrency(
                        data?.OverviewS3?.recoveredInSME,
                        format
                      ) || 0}
                    </span>
                  </div>
                  <div className="count">
                    <p>Count</p>
                    <div className="count-info">
                      <span>
                        {formatWithCommas(
                          data?.OverviewS3?.recoveredInSMECount
                        ) || 0}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="title_info overall">
              <div className="title_head">
                {overview_loading ? (
                  <Skeleton.Input size="small" />
                ) : (
                  <span>Retail</span>
                )}
                <img src={infoIcon} alt="icon" />
              </div>
              {overview_loading ? (
                <Skeleton.Input size="small" />
              ) : (
                <div className="value_count">
                  <div className="value">
                    <p>Value</p>
                    <span>
                      {formatCurrency(
                        data?.OverviewS3?.recoveredInRetail,
                        format
                      ) || 0}
                    </span>
                  </div>
                  <div className="count">
                    <p>Count</p>
                    <div className="count-info">
                      <span>
                        {formatWithCommas(
                          data?.OverviewS3?.recoveredInRetailCount
                        ) || 0}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisPage;
export const Card1 = ({ data, format }) => {
  const { name, value, count, chartData, percentage, icon } = data;
  return (
    <div className="analysis-card-1">
      <div className="info">
        <div className="top">
          <img src={icon} alt="" />
          <h2>{name}</h2>
        </div>
        <div className="bottom">
          <div className="left">
            <span>Value</span>
            <p>{formatCurrency(value, format)}</p>
          </div>
          <div className="right">
            <span>Count</span>
            <div className="info">
              <p>{formatWithCommas(count)}</p>
              <div className="percentage-val">{percentage}%</div>
            </div>
          </div>
        </div>
      </div>
      <div className="chart-info">
        <HalfDonutPieChart
          intValue={true}
          /* [remainder, achieved] - the default palette painted the
             remainder red, which read as a failure state */
          colors={["#eef1f8", "#6287ff"]}
          data={data?.chartData}
          /* cy sat at 30 with a 55px radius, so the arc was drawn 25px above
             its own svg and the stylesheet dragged it back with negative
             margins and a forced svg size. Sized to fit its box instead, and
             kept small: it is context for the figure, not the headline. */
          width={86}
          height={48}
          cx={43}
          cy={43}
          innerRadius={27}
          outerRadius={43}
        />
      </div>
    </div>
  );
};

const BalancePOSCard = ({ balancePOSData, name, format }) => {
  /* the two segments already carry their values, so the split between them
     is worth drawing rather than leaving the reader to compare two figures */
  const items = balancePOSData?.items || [];
  const splitTotal = items.reduce((sum, i) => sum + (Number(i?.value) || 0), 0);
  const share = (item) =>
    splitTotal > 0 ? ((Number(item?.value) || 0) / splitTotal) * 100 : 0;

  return (
    <div className="balance-pos-card">
      <div className="header">
        <span className="title">{name}</span>
        <span className="value">
          {formatCurrency(balancePOSData.totalValue, format)}
          <span className="percentage">{balancePOSData.percentage}%</span>
        </span>
      </div>

      {splitTotal > 0 && (
        <div className="pos-split">
          <div className="pos-split-bar">
            {items.map((item, idx) => (
              <span
                key={item?.title}
                className={`seg seg-${idx}`}
                style={{ width: `${share(item)}%` }}
              />
            ))}
          </div>
          <div className="pos-split-legend">
            {items.map((item, idx) => (
              <span key={item?.title} className={`legend-item seg-${idx}`}>
                <i className="dot" />
                {item?.title}
                <b>{Math.round(share(item))}%</b>
              </span>
            ))}
          </div>
        </div>
      )}

      {balancePOSData.items.map((item, idx) => (
        <div key={idx} className="pos-item">
          <div className="item-header">
            <span className="icon">
              <img src={item?.title === "SME" ? smeIcon : retailIcon} alt="" />
            </span>
            <span className="item-title">{item.title}</span>
            <span className="info-icon">
              <Tooltip title={item.title}> {/* Sample Text added */}
                <img src={infoIcon} alt="icon" />
              </Tooltip>
            </span>
          </div>
          <div className="item-details">
            <div className="detail">
              <span className="label">Value</span>
              <div>
                <span className="amount">
                  {formatCurrency(item.value, format)}
                </span>
                <span className="badge">{item.valuePercentage}%</span>
              </div>
            </div>
            <div className="detail">
              <span className="label">Count</span>
              <div>
                <span className="amount">{formatWithCommas(item?.count)}</span>
                <span className="badge">{item?.countPercentage}%</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
